const TONES = {
  enter: [
    { freq: 523, duration: 0.11, gain: 0.06 },
    { freq: 659, start: 0.1, duration: 0.16, gain: 0.07 },
  ],
  leave_other: [
    { freq: 392, duration: 0.12, gain: 0.055 },
    { freq: 294, start: 0.13, duration: 0.16, gain: 0.05 },
  ],
  leave_break: [
    { freq: 440, duration: 0.1, gain: 0.05 },
    { freq: 349, start: 0.16, duration: 0.18, gain: 0.048 },
  ],
  leave_exit: [
    { freq: 392, duration: 0.1, gain: 0.055 },
    { freq: 330, start: 0.12, duration: 0.12, gain: 0.05 },
    { freq: 262, start: 0.26, duration: 0.2, gain: 0.048 },
  ],
};

let sharedCtx = null;
let unlocked = false;
let queue = Promise.resolve();

function getAudioContext() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    if (!sharedCtx || sharedCtx.state === "closed") sharedCtx = new Ctx();
    return sharedCtx;
  } catch {
    return null;
  }
}

export function unlockVoPresenceAudio() {
  unlocked = true;
  const ctx = getAudioContext();
  if (ctx && ctx.state === "suspended") {
    void ctx.resume().catch(() => {});
  }
}

async function ensureRunning() {
  const ctx = getAudioContext();
  if (!ctx) return false;
  if (ctx.state === "suspended") {
    try {
      await ctx.resume();
    } catch {
      return false;
    }
  }
  if (ctx.state === "running") {
    unlocked = true;
    return true;
  }
  return false;
}

async function playToneSequence(steps) {
  const ready = await ensureRunning();
  if (!ready) return false;
  const ctx = getAudioContext();
  if (!ctx) return false;
  for (const step of steps) {
    const { freq, start = 0, duration = 0.1, gain = 0.055 } = step;
    if (!freq || duration <= 0) continue;
    const osc = ctx.createOscillator();
    const gainNode = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    const t0 = ctx.currentTime + start;
    const attack = Math.min(0.012, duration * 0.25);
    gainNode.gain.setValueAtTime(0.0001, t0);
    gainNode.gain.linearRampToValueAtTime(gain, t0 + attack);
    gainNode.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
    osc.connect(gainNode);
    gainNode.connect(ctx.destination);
    osc.start(t0);
    osc.stop(t0 + duration + 0.03);
  }
  return true;
}

export function playVoPresenceSound(kind) {
  const steps = TONES[kind] || TONES.leave_other;
  queue = queue
    .then(() => playToneSequence(steps))
    .catch(() => false);
  return queue;
}

export function isVoPresenceAudioUnlocked() {
  return unlocked;
}
